// NotificationContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';

const NotificationContext = createContext();
let externalNotify = null;

export const useNotification = () => useContext(NotificationContext);

const normalizeNotificationMessage = (message) => {
  if (!message) return '';
  if (typeof message === 'string') return message;
  if (Array.isArray(message)) return message.map(normalizeNotificationMessage).filter(Boolean).join('\n');
  if (typeof message === 'object') {
    return message.detail || message.message || message.error || Object.values(message).map(normalizeNotificationMessage).filter(Boolean).join('\n');
  }
  return String(message);
};

const NotificationMessage = ({ message }) => {

  const lineClampStyle = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3,
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <div style={lineClampStyle} title={message}>
        {message}
      </div>
    </div>
  );
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (props) => {
    const message = normalizeNotificationMessage(props.message);
    if (!message) return;

    if (props.type === 'error') {
      console.warn('[ShowNotification:error]', {
        message,
        rawProps: props,
      });
      console.trace('[ShowNotification:error trace]');
    }

    if (message === '{0}') return;

    const id = `${Date.now()}-${Math.random()}`;
    setNotifications((prev) => [...prev, { id, ...props, message }]);

    if (!props.sticky) {
      setTimeout(() => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
      }, props.duration || 5000);
    }
  };

  const closeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  useEffect(() => {
    externalNotify = showNotification;
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationGroup
        style={{
          top: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          position: 'fixed',
          zIndex: 100000,
          maxWidth: '90vw',
        }}
      >
        {notifications.map((n) => (
          <Notification
            key={n.id}
            type={{ style: n.type || 'info', icon: false }}
            closable={true}
            onClose={() => closeNotification(n.id)}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 10,
                fontSize: 14,
                lineHeight: 1.5,
                whiteSpace: 'normal',
              }}
            >
              <NotificationMessage message={n.message} />
            </div>
          </Notification>
        ))}
      </NotificationGroup>
    </NotificationContext.Provider>
  );
};

export const notifyError = (message, duration = 5000) => {
  if (externalNotify) {
    externalNotify({ type: 'error', message, duration });
  } else {
    console.warn('Notification system not ready');
  }
};
